import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css"; // Optional: If you have global styles
import '@babel/polyfill';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
